import React, { useEffect } from 'react';
import { KTSVG } from 'src/_metronic/helpers';
import { useAppDispatch } from 'src/services/redux/app/Store';
import { maintenanceList } from 'src/services/redux/slices/maintenance/maintenance.slice';

type Props = {};

export default function Maintenance({}: Props) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(maintenanceList({}));
  }, []);
  return (
    <div className="bg-white">
      <div style={{ height: '100vh' }} className="container d-flex align-items-center justify-content-center bg-white">
        <div className="alert alert-dismissible bg-light-primary d-flex flex-center flex-column py-10 px-10 px-lg-20 mb-10">
          <span className="svg-icon svg-icon-5tx  mb-5">
            <KTSVG path="/media/icons/duotone/Tools/Tools.svg" className="svg-icon-5x " />
          </span>
          <div className="text-center">
            <h5 className="fw-bolder fs-1 mb-5">Bakım Çalışması</h5>

            <div className="separator separator-dashed border-info opacity-25 mb-5"></div>

            <div className="mb-9">Bakım çalışması nedeniyle geçiçi bir süre hizmet veremiyoruz. </div>
          </div>
        </div>
      </div>
    </div>
  );
}
